ecDialogService.$inject = ['$rootScope', '$compile', '$timeout'];

export default function ecDialogService($rootScope, $compile, $timeout) {
  return {
    open,
  };

  /**
   * Permite abrir una nueva ventana.
   *
   * @param {object} data Los datos para crear la ventana, detalle:
   * @param {string} [data.template] El contenido de la ventana
   * @param {string} [data.label] El titulo de la ventana
   * @param {string} [data.icon] El icono de la ventana.
   * @param {string} [data.id] el id de la ventana
   * @param {string} [data.title] DEPRECATED, usar `data.label` El titulo de la ventana. Se mantiene por retrocompatibilidad.
   * @param {object} [data.params] DEPRECATED, usar `data.scope`. Objeto de datos del scope angularjs, en `scope.params`.
   * @param {object} [data.scope] Objeto de datos del scope angularjs. Nota que por retro compatibilitad debería pasarse un objeto { params: { ...mis datos..} }
   * @returns {Promise}
   *
   * NOTA data.width y data.height no se utilizan porque el EwcDialog intenta calcular el tamaño del contenido.
   */
  function open(data) {
    const unbinds = [];
    const eDialog = document.createElement('ewc-dialog');
    const { template = '', name = '', title = '', label = title, icon = '', id = '', params = {}, scope = params, maximize = false, noOverlayClose = false } = data;
    name && eDialog.setAttribute('name', name);
    label && eDialog.setAttribute('label', label);
    icon && eDialog.setAttribute('icon', icon);
    id && eDialog.setAttribute('id', id);
    eDialog.setAttribute('style', 'z-index: 999999996');
    noOverlayClose && eDialog.setAttribute('no-overlay-close', '');
    eDialog.setAttribute('close', '');
    maximize && eDialog.setAttribute('maximize', '');
    eDialog.setAttribute('loading', '');

    if (template) {
      eDialog.innerHTML = template;
    }
    document.body.appendChild(eDialog);

    return new Promise(resolve => {
      const newScope = $rootScope.$new(true);
      const retrocompatibilidad = { id, params };
      Object.assign(newScope, retrocompatibilidad, scope);

      const api = {
        maximize: eDialog.maximize,
        close: eDialog.close,
      };

      unbinds.push(() => newScope.$destroy());

      eDialog.addEventListener('EwcDialog:destroy', onDestroy);
      unbinds.push(() => eDialog.removeEventListener('EwcDialog:destroy', onDestroy));

      $compile(eDialog.firstElementChild)(newScope);
      $timeout(() => {
        $timeout(() => {
          // doble $timeout para por ejemplo el formBuilder que tarda mas
          // así, cuvrimos la mayoría de casos
          eDialog.loading = false;
          resolve(api);
        });
      });
    });

    function onDestroy() {
      eDialog && eDialog.removeEventListener('EwcDialog:destroy', onDestroy);
      unbinds.forEach(fn => fn());
    }
  }
}
